

import { ReportHSMBroadcastService } from "@/services";
import { httpClientOmni } from "@/libraries";


const state = {
    data: [],
    failed: 0,
    read: 0,
    delivered: 0,
    sent: 0,
    total_recipient: 0,
    loading: false,
    loadingCount: false,
    pagination: {
        current: 1,
        pageSize: 10,
        total: 0
    },
    search: '',
    masterHsmTemplate: [],
    masterStatus: [],
}

const mutations = {
    SET_DATATABLE(state, data) {
        state.data = data.data
        state.pagination.total = data.total
    },
    SET_COUNT_REPORT(state, data) {
        state.failed = data.failed || 0;
        state.read = data.read || 0;
        state.delivered = data.delivered || 0;
        state.sent = data.sent || 0;
        state.total_recipient = data.total_recipient || 0;
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_LOADING_COUNT(state, loading) {
        state.loadingCount = loading
    },
    SET_PAGINATION(state, pagination) {
        state.pagination = { ...state.pagination, ...pagination }
    },
    SET_FILTER_TEXT(state, text) {
        state.search = text
    },
    SET_STATUS(state, status) {
        state.masterStatus = status
    },
    SET_TEMPLATE(state, template) {
        state.masterHsmTemplate = template
    },
}

const actions = {
    // OLD
    /*
    async fetchDatatable({ commit, state }) {
      try {
        commit('SET_LOADING', true)
        const response = await httpClientOmni.get('v3/whatsapp-flows/datatable', {
          params: {
            page: state.pagination.current,
            per_page: state.pagination.pageSize,
            sort: 'id|desc',
            search: state.search
          }
        })
        commit('SET_DATATABLE', response.data)
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    */

    async fetchDatatableHSM({ commit, state }, options = {}) {
        try {

            // const { commit, state } = context;  // Ambil commit dan state dari context

            const { filters = {}, sort = null } = options; // Use destructuring with default values
            commit('SET_LOADING', true);

            const response = await ReportHSMBroadcastService.datatable({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters, // Spread filters to include additional options
            });

            commit('SET_DATATABLE', response.data);
        } catch (error) {
            console.error('Failed to fetch flows:', error);
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async fetchDatatableHSMTemplateUsage({ commit, state }, options = {}) {
        try {

            // const { commit, state } = context;  // Ambil commit dan state dari context

            const { filters = {}, sort = null } = options; // Use destructuring with default values
            commit('SET_LOADING', true);

            const response = await ReportHSMBroadcastService.datatableTemplateUsage({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters, // Spread filters to include additional options
            });

            commit('SET_DATATABLE', response.data);
        } catch (error) {
            console.error('Failed to fetch flows:', error);
        } finally {
            commit('SET_LOADING', false);
        }
    },


    async fetchCountReport({ commit, state }, options = {}) {
        try {
            const { filters = {}, sort = null } = options;
            commit('SET_LOADING_COUNT', true);

            const response = await ReportHSMBroadcastService.countReport({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters,
            });

            commit('SET_COUNT_REPORT', response.data.data);
        } catch (error) {
            console.error('Failed to fetch count report:', error);
        } finally {
            commit('SET_LOADING_COUNT', false);
        }
    },

    async fetchCountTemplateUsageReport({ commit, state }, options = {}) {
        try {
            const { filters = {}, sort = null } = options;
            commit('SET_LOADING_COUNT', true);

            const response = await ReportHSMBroadcastService.countReportTemplateUsage({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters,
            });

            commit('SET_COUNT_REPORT', response.data.data);
        } catch (error) {
            console.error('Failed to fetch count report:', error);
        } finally {
            commit('SET_LOADING_COUNT', false);
        }
    },


    async fetchStatusBroadcastMsg({ commit }) {
        try {
            const response = await httpClientOmni.get('v3/master/status-of-broadcast-message')
            if (response.data && Array.isArray(response.data.data)) {
                commit('SET_STATUS', response.data.data)
            }
        } catch (error) {
            console.error('Failed to fetch tags:', error)
        }
    },

    async fetchHsmTemplate({ commit }) {
        try {
            const response = await httpClientOmni.get('v3/master/hsm-templates-by-app-id')
            if (response.data && Array.isArray(response.data.data)) {
                commit('SET_TEMPLATE', response.data.data)
            }
        } catch (error) {
            console.error('Failed to fetch template:', error)
        }
    },


}

const getters = {
    statusBroadcastMsgOptions: state => state.masterStatus,
    hsmTemplateOptions: state => state.masterHsmTemplate,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}